<template>
  <div>
    <div class="map" ref="spec-map">
      <div class="custom-control">
        <a @click="toggle3d()">
          <img src="@/assets/icons/td.svg" alt="">
        </a>
      </div>

      <app-map-label :labels="{available: false, sold: false, favorites: false, spec: true}"></app-map-label>
    </div>
  </div>
</template>

<script>

import Map from "@/mixins/journey/SpecMap";
import Loading from "@/components/journey/Loading";
import PackageCard from "@/components/journey/spec/PackageCard";
import PackageFilter from "@/components/journey/spec/PackageFilter";
import MapLabel from "@/components/journey/MapLabel";

export default {
  name: 'app-community-map',
  mixins: [Map],
  components: {
    'app-package-filter': PackageFilter,
    'app-package-card': PackageCard,
    'app-loading': Loading,
    'app-map-label': MapLabel
  },
  data() {
    return {
      initiatedMap: false,
      isPitched: true,
      sub: null,
    }
  },
  props: {
    filteredHnlList: {
      type: Array
    }
  },
  watch: {
    filteredHnlList: {
      deep: true,
      handler(val, oldval) {
        if (val !== oldval) {
          this.filterPackages(val);
        }
      }
    }
  },
  mounted() {
    this.favoriteHnl = this.$store.state.favoriteStore.favoriteHnl;

    this.sub = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setMasterplanConfig') {
        this.masterplanConfig = this.$store.getters.masterplanConfig;
        this.loadMap();
      }

      if (mutation.type === 'setHomeGeoJson') {
        // console.log(this.$store.getters.homeGeoJson);
      }
    });

    this.$store.dispatch('fetchMasterplanConfig');
    this.$store.dispatch('fetchHomeGeoJson');
  },
  beforeDestroy() {
    this.sub();
  },
  methods: {
    selectHome: function (hnlSummary) {
      this.activeHome = hnlSummary;
    },

    nextPage: function (ev) {
      this.activeHomeDetail = ev;
      this.$emit('goNext', true);
    },

    loadMap() {
      if (!this.initiatedMap && this.masterplanConfig && this.filteredHnlList) {
        this.loading = false;
        this.initiatedMap = true;
        this.initMap(this.masterplanConfig, this.filteredHnlList);
      }
    },

    filterPackages: function () {
      if (this.initiatedMap) {
        this.filterMapLots(this.filteredHnlList);
      }
    },

    toggle3d: function () {
      const pitch = this.isPitched ? 0 : 60
      this.isPitched = !this.isPitched;
      this.map.flyTo({
        pitch: pitch
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/spec/SpecMap.vue